import AppShell from "@/components/layout/AppShell";
import ParentCommunicationCenterTab from "@/components/communications/ParentCommunicationCenterTab";

export default function ParentCommunicationCenterPage() {
  return (
    <AppShell pageTitle="Parent Communication Center Email" breadcrumb>
      <ParentCommunicationCenterTab />
    </AppShell>
  );
}
